import React from 'react';
import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import CardBrandLogo from './CardBrandLogo';
import {
  CARD_BRAND_LABELS,
  cardBrandOptions,
  type CardBrandCode,
  type ExtraCardBrand,
} from '../../utils/cardBrands';

interface Props {
  value: string;
  onChange: (brand: CardBrandCode) => void;
  enabledBrands: ExtraCardBrand[];
  error?: boolean;
  helperText?: React.ReactNode;
  disabled?: boolean;
}

/** Bandeira do cartão no lançamento; só faz sentido quando há bandeiras extras habilitadas. */
const CardBrandSelect: React.FC<Props> = ({ value, onChange, enabledBrands, error, helperText, disabled }) => {
  const options = cardBrandOptions(enabledBrands);
  return (
    <FormControl fullWidth size="small" required error={error} disabled={disabled}>
      <InputLabel>Bandeira do cartão</InputLabel>
      <Select
        label="Bandeira do cartão"
        value={value}
        onChange={(e) => onChange(e.target.value as CardBrandCode)}
        renderValue={(selected) => {
          const brand = selected as CardBrandCode;
          if (!brand) return '';
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CardBrandLogo brand={brand} height={18} />
              <span>{CARD_BRAND_LABELS[brand]}</span>
            </Box>
          );
        }}
      >
        {options.map((brand) => (
          <MenuItem key={brand} value={brand}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
              <CardBrandLogo brand={brand} height={20} />
              <span>{CARD_BRAND_LABELS[brand]}</span>
            </Box>
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default CardBrandSelect;
